import { useParams } from "react-router-dom";
import { ExoProject } from "../../components/exo/ExoProject";

export const ProjectManagement = () => {
  const { pid } = useParams();
  return <ExoProject projectId={pid} />;
};
